import { CodeLanguages } from '../code';

export const AgentCode = ({ agentId, params }) => {
  const body = JSON.stringify(params, null, 2);
  const endpoint = `https://api.fetchfox.ai/api/agent/${agentId}/run`;
  const snippets = [
    {
      name: 'curl',
      language: 'bash',
      code: `curl -X POST ${endpoint} \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer $FETCHFOX_API_KEY" \\
  -d '${body}'`,
    },
    {
      name: 'Node.js (fetch)',
      language: 'javascript',
      code: `const response = await fetch('${endpoint}', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    Authorization: \`Bearer \${process.env.FETCHFOX_API_KEY}\`,
  },
  body: JSON.stringify(${body}),
});

const data = await response.json();
console.log(data.jobId);`,
    },
    {
      name: 'Node.js (npm)',
      language: 'javascript',
      code: `// npm install fetchfox-sdk
import * as fox from 'fetchfox-sdk';

fox.configure({ apiKey: process.env.FETCHFOX_API_KEY });

const data = await fox.call('POST', '/api/agent/${agentId}/run', ${body});
console.log(data.jobId);`,
    },
    {
      name: 'Python',
      language: 'python',
      code: `# pip install requests
import json
import os
import requests

payload = json.loads(${JSON.stringify(body)})
response = requests.post(
    '${endpoint}',
    headers={'Authorization': f"Bearer {os.environ['FETCHFOX_API_KEY']}"},
    json=payload,
)
response.raise_for_status()
print(response.json()['jobId'])`,
    },
  ];

  return <CodeLanguages snippets={snippets} />;
};
